import React from "react";
import MainPageLayout from "../../layouts/MainPageLayout";

const BlogComponent = ({ isMobile }) => {
  return (
    <>
      <MainPageLayout
        isMobile={isMobile}
        pageEndpoint={"blogs"}
        allData={true}
        page="blogs"
      />
    </>
  );
};

export default BlogComponent;
